if (!window.Eurus.loadedScript.includes('locales-form.js')) {
  window.Eurus.loadedScript.push('locales-form.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          this.openCountry = true;
          Alpine.store('xPopup').open = true;
        },
        close() {
          this.openCountry = false;
          Alpine.store('xPopup').open = false;
        }
      }))
    });
  });
}